import { actions } from "../cds/actions";
import { mutations } from "../cds/mutations";
import { ICDSState, stateDeBase } from "../models";

export const state: ICDSState = stateDeBase();

export default {
  state,
  actions,
  mutations,
};
